var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1489_3249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 14.75C9.09338 14.75 9.70898 14.1344 9.70898 13.375C9.70898 12.6156 9.09338 12 8.33398 12C7.57459 12 6.95898 12.6156 6.95898 13.375C6.95898 14.1344 7.57459 14.75 8.33398 14.75Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 11.0493C21.5288 10.1473 21.625 9.11975 21.625 8.413C21.625 3.34659 15.7217 1.45825 12 1.45825C9.5855 1.45825 7.84292 2.7535 7.25717 3.25675C5.42383 3.36217 2.375 4.52909 2.375 8.413C2.375 9.12984 2.47033 10.1528 2.57392 11.0503C2.10993 11.237 1.71226 11.558 1.43185 11.9722C1.15144 12.3863 1.00107 12.8748 1 13.3749C1.00191 14.0083 1.24259 14.6176 1.67401 15.0813C2.10543 15.545 2.69584 15.829 3.32742 15.8765C4.5695 19.4818 7.98408 22.0833 12 22.0833C16.0159 22.0833 19.4305 19.4827 20.6726 15.8765C21.3042 15.829 21.8946 15.545 22.326 15.0813C22.7574 14.6176 22.9981 14.0083 23 13.3749C22.999 12.8744 22.8484 12.3856 22.5676 11.9712C22.2869 11.5569 21.8887 11.2358 21.4242 11.0493ZM19.4937 15.0497L19.4919 15.0543V15.057C18.5514 18.3158 15.5521 20.7083 12 20.7083C8.12708 20.7083 4.91325 17.8638 4.30825 14.1532L5.22308 10.9531C6.03983 10.6937 7.8695 9.95942 8.67067 8.40934C9.90358 9.57442 12.6664 11.0044 18.8145 11.0805L19.6927 14.1486C19.6443 14.4526 19.5779 14.7535 19.4937 15.0497Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.666 14.75C16.4254 14.75 17.041 14.1344 17.041 13.375C17.041 12.6156 16.4254 12 15.666 12C14.9066 12 14.291 12.6156 14.291 13.375C14.291 14.1344 14.9066 14.75 15.666 14.75Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8134 16.776C13.3243 17.2417 12.6748 17.5014 11.9994 17.5014C11.324 17.5014 10.6744 17.2417 10.1853 16.776C10.0539 16.6493 9.87753 16.58 9.69505 16.5834C9.51257 16.5867 9.3389 16.6624 9.21223 16.7938C9.08557 16.9252 9.0163 17.1016 9.01965 17.2841C9.023 17.4665 9.09871 17.6402 9.23011 17.7669C9.99369 18.5039 10.9965 18.8715 11.9994 18.8715C13.0022 18.8715 14.005 18.5039 14.7686 17.7669C14.8943 17.6389 14.9651 17.467 14.9659 17.2877C14.9668 17.1084 14.8976 16.9358 14.7731 16.8067C14.6487 16.6776 14.4788 16.6021 14.2995 16.5964C14.1203 16.5906 13.9459 16.6551 13.8134 16.776Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_3249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/myProfile.48831e05dee79193b012c449a7a3a905.svg";
export { ForwardRef as ReactComponent };